import { useTranslation } from 'react-i18next';
import type { AuditActor } from '../../api/audit';

/** Localized names of audit actions and entity types (unknown codes are shown as they are). */
export function useAuditLabels() {
  const { t } = useTranslation();
  return {
    action: (code: string) => t(`audit.actions.${code}`, { defaultValue: code }),
    entityType: (code: string) => t(`audit.entityTypes.${code}`, { defaultValue: code }),
  };
}

/** "Jana Kováčová (jana.kovacova)", or "Systém" for jobs and migrations. */
export function ActorName({ actor }: { actor: AuditActor }) {
  const { t } = useTranslation();
  if (actor.system) return <>{t('audit.system')}</>;
  const name = actor.displayName || actor.username || actor.sub;
  return (
    <>
      {name}
      {actor.username && actor.username !== name && <span className="govuk-hint app-inline-hint"> ({actor.username})</span>}
    </>
  );
}
